import { Injectable } from '@angular/core';
import { IQuotationsQuotation, IQuotationVatConfiguration } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { RuntimeError } from "libraries/service/error-tracing/runtime-error.model";
import { EVatDisplayMode } from "libraries/service/vat/vat.interface";

@Injectable({
  providedIn: 'root'
})
export class VatService {

  public getValueAccordingToVat<T>(input: IQuotationsQuotation|IQuotationVatConfiguration, noVat: T, excludingVAT: T, includingVAT: T = excludingVAT): T {

    if (!input) {
      return null;
    }

    let vatDisplayMode: EVatDisplayMode;
    let vatRate: number;

    if ("retail" in input && "vat" in input) {
      // IQuotationsQuotation
      vatDisplayMode = input.retail && input.retail.displayMode;
      vatRate = input.vat.rate;
    } else if ("vatRate" in input) {
      // IQuotationVatConfiguration
      vatDisplayMode = input.vatDisplayMode;
      vatRate = input.vatRate;
    } else {
      throw new RuntimeError('Parameter should be IQuotationsQuotation|IQuotationVatConfiguration', input);
    }

    if (!vatRate) {
      return noVat;
    } else if (vatDisplayMode === EVatDisplayMode.excludingVAT) {
      return excludingVAT;
    } else if (vatDisplayMode === EVatDisplayMode.includingVAT) {
      return includingVAT;
    }

    throw new RuntimeError(`Invalid VAT setup ${vatDisplayMode} ${vatRate}`);
  }

  public isWithVat(quotation: IQuotationsQuotation): boolean {
    return quotation.vat && Boolean(quotation.vat.rate);
  }

  public getVatConfiguration(quotation: IQuotationsQuotation): IQuotationVatConfiguration {
    if (!quotation) {
      return null;
    }
    const result: IQuotationVatConfiguration = {
      vatRate: quotation.vat.rate,
      vatDisplayMode: quotation.retail.displayMode,
    };
    return result;
  }
}
